export default __webpack_public_path__ + "static/media/tomato.6c723cfe.png";